'use client'

import { Tabs } from '@mantine/core'
import { ITabsItem } from '@partment/types'
import Link from 'next/link'
import { useMobileBottomNavBar } from '../..'
import classes from './style.module.css'

interface IMobileBottomNavBarProps {
  tabs: ITabsItem[]
}

export function MobileBottomNavBar({ tabs }: IMobileBottomNavBarProps) {
  const { setValue, value } = useMobileBottomNavBar(tabs)

  return (
    <Tabs
      variant='none'
      className={classes.tabs}
      classNames={classes}
      value={value}
      onChange={setValue}
    >
      <Tabs.List className={classes.list}>
        {tabs.map((tab) => (
          <Tabs.Tab value={tab.href} key={tab.href} className={classes.tab}>
            <Link href={tab.href} className={classes.tabHref}>
              <div
                data-active={value === tab.href && 'true'}
                className={classes.iconBackground}
              >
                {tab.icon}
              </div>
              {tab.label}
            </Link>
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  )
}
